//#region src/utils/zod-to-json-schema/parsers/boolean.ts
function parseBooleanDef() {
	return { type: "boolean" };
}

//#endregion
export { parseBooleanDef };
//# sourceMappingURL=boolean.js.map